import { useMemo } from 'react';
import { assert } from '@varos/util-typescript';
import { ReportingShellLoaderBaseConfig } from '../../../base';
import { ChatDetailLoader } from './chatDetailInterface';
import { ChatDetailAggregate } from './chatDetailModel';

const MAX_MESSAGES = 35;

export function createChatDetailLoader(
    config: ReportingShellLoaderBaseConfig
): ChatDetailLoader {
    const {
        kernel,
        repository: { research: repository, platform, assistant },
    } = config;
    return {
        useLoad(context, props): ChatDetailAggregate {
            const threadQuery = assistant.thread.useLookup(
                context,
                { id: props.thread.id },
                {
                    suspense: true,
                }
            );
            // const contentQuery = repository.content.useLookup(
            //     context,
            //     { contentId: props.content?.id! },
            //     { suspense: true, enabled: !!props.content?.id }
            // );
            assert(threadQuery.status === 'success', 'expected suspense');
            // assert(contentQuery.status === 'success', 'expected suspense');

            const messageQuery = assistant.message.useFind(
                context,
                {
                    thread: props.thread.id,
                    limit: MAX_MESSAGES,
                },
                {
                    suspense: true,
                }
            );

            // console.log('messageQuery', messageQuery.data);

            assert(messageQuery.status === 'success', 'expected suspense');

            return {
                // content: contentQuery.data,
                thread: threadQuery.data,
                messages: messageQuery.data,
            };
        },
    };
}
